export default __webpack_public_path__ + "static/media/sketch13.e5db8cd6.png";